import { render, staticRenderFns } from "./medicationPayment.vue?vue&type=template&id=553072d0&scoped=true"
import script from "./medicationPayment.vue?vue&type=script&lang=js"
export * from "./medicationPayment.vue?vue&type=script&lang=js"
import style0 from "./medicationPayment.vue?vue&type=style&index=0&id=553072d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553072d0",
  null
  
)

export default component.exports